export default "__VITE_ASSET__973f8f61__"